export const LOG_ERROR = 'LOG_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
